import { ApiMethod } from "@core/interfaces/api.ts";
import { HttpService } from "@core/services/http.service.ts";
import {
  CardType,
  DashboardExternData,
  DashboardInternData,
  ProfilDto,
} from "@modules/dashbord/dashbord.model.ts";
import { AxiosProgressEvent } from "axios";

export class ProfileService extends HttpService {
  private readonly APIURL = process.env.REACT_APP_API_URL;

  getAllProfils() {
    this.urlAPI = this.APIURL + "/profil";
    return this.doGet<ProfilDto[]>();
  }

  getInternStat() {
    this.urlAPI = this.APIURL + "/statistic";
    return this.doGet<DashboardInternData>();
  }
  
  getExternStat(params: {
    dateDebut?: string;
    dateFin?: string;
    typePlainte?: number;
    region?: number;
    district?: number;
    commune?: number;
    fokontany?: number;
  }) {
    const queryParams = new URLSearchParams({
      dateDebut: params.dateDebut as string,
      dateFin: params.dateFin ?? "",
      typePlainte: params.typePlainte?.toString() ?? "",
      region: params.region?.toString() ?? "",
      district: params.district?.toString() ?? "",
      commune: params.commune?.toString() ?? "",
      fokontany: params.fokontany?.toString() ?? "",
    });

    this.urlAPI = this.APIURL + `/statistic/externe?${queryParams}`;
    return this.doGet<DashboardExternData>();
  }

  importFileExternalAgent(
    file: File,
    onUploadProgress?: (progressEvent: AxiosProgressEvent) => void
  ) {
    const url = this.APIURL + "/import/plaintes";
    const formData = new FormData();
    formData.append("file", file);

    return this.doRequest<any, FormData>(url, ApiMethod.POST, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
      onUploadProgress,
    });
  }

  checkFileExists(
    file: File,
    onUploadProgress?: (progressEvent: AxiosProgressEvent) => void
  ) {
    const url = this.APIURL + "/import/plaintes/check";
    const formData = new FormData();
    formData.append("file", file);

    return this.doRequest<{ exists: boolean }, FormData>(url, ApiMethod.POST, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
      onUploadProgress,
    });
  }
  
  getFileInternAgent() {
    this.urlAPI = this.APIURL + `/export/interne`;
    return this.doRequest<Blob, undefined>(
      this.urlAPI,
      ApiMethod.GET,
      undefined,
      {
        responseType: "blob",
      }
    );
  }

  getFileExternAgent(params: {
    dateDebut?: string;
    dateFin?: string;
    typePlainte?: number;
    region?: number;
    district?: number;
    commune?: number;
    fokontany?: number;
  }) {
    const queryParams = new URLSearchParams({
      dateDebut: params.dateDebut as string,
      dateFin: params.dateFin ?? "",
      typePlainte: params.typePlainte?.toString() ?? "",
      region: params.region?.toString() ?? "",
      district: params.district?.toString() ?? "",
      commune: params.commune?.toString() ?? "",
      fokontany: params.fokontany?.toString() ?? "",
    });
    this.urlAPI = this.APIURL + `/export/externe?${queryParams}`;
    return this.doRequest<Blob, undefined>(
      this.urlAPI,
      ApiMethod.GET,
      undefined,
      {
        responseType: "blob",
      }
    );
  }

  getInternCard() {
    this.urlAPI = this.APIURL + `/statistic/internal-card`;
    return this.doGet<CardType[]>();
  }
}
